module.exports = __webpack_public_path__ + "img/heart-fill.a7e73078.svg";